<template>
  <div class="customFormBox2">
    <el-form :model="ruleForm" :rules="rules" size="mini"  :inline="true" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-row>
        <el-col :span="12">
          <el-form-item label="任务名称" prop="taskName">
            <el-input v-model="ruleForm.taskName" :disabled="isDisabled"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="任务类型" prop="taskType">
            <el-select v-model="ruleForm.taskType" :disabled="isDisabled" placeholder="请选择" style="width:250px;">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="执行类" prop="runClass">
            <el-input v-model="ruleForm.runClass" :disabled="isDisabled"></el-input>
          </el-form-item>
          <el-form-item label="定时时间" prop="taskTimer">
            <el-input v-model="ruleForm.taskTimer" :disabled="isDisabled"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" class="extraText">
          <el-form-item label="任务描述" prop="remark">
            <el-input type="textarea" v-model="ruleForm.remark" :disabled="isDisabled"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
const options = [
  {
    value: 'system',
    label: 'system'
  }
];

export default {
  name: 'MyContent',
  components: {},
  props: {
    ruleForm: {
      type: Object
    },
    dialogType: String
  },
  data() {
    return {
      options,
      rules: {
        taskName: [
          {
            required: true,
            message: '请输入任务名称',
            trigger: 'blur'
          }
        ],
        taskType: [
          {
            required: true,
            message: '请选择任务类型',
            trigger: 'blur'
          }
        ],
        runClass: [
          {
            required: true,
            message: '请输入执行类',
            trigger: 'blur'
          }
        ],
        taskTimer: [
          {
            required: true,
            message: '请输入定时时间',
            trigger: 'blur'
          }
        ]
      }
    };
  },
  computed: {
    isDisabled() {
      return this.dialogType === 'detail';
    }
  },
  methods: {
    handelStatField(data) {
      console.warn('emit on');
      this.ruleForm.statField = data.join('.');
      console.warn(this.ruleForm.statField);
    },

    formatTooltip(val) {
      console.warn(val);
      return val / 100;
    }
  }
};
</script>

<style lang="scss">
.customFormBox2 {
  .demo-ruleForm {
    .extraText {
      .el-textarea {
        textarea {
          height: 86px;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.customFormBox2 {
  .demo-ruleForm {
    text-align: center;
    .extraText {
      .el-textarea {
        textarea {
          height: 86px;
        }
      }
    }
    .el-textarea,
    .el-input,
    .el-input-number {
      width: 250px;
    }
  }
}
</style>
